/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable sonarjs/no-identical-functions */
import {
  ValidatorFn,
  AbstractControl,
  FormGroup,
  FormArray,
  FormControl,
  ValidationErrors,
} from '@angular/forms';
import { SupplementProductByState } from './util';

export function minMaxLengthWithNospaces(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const passwordRegEx = /^\S{9,64}$/;
    result = passwordRegEx.test(control.value);
    return result ? null : { invalidMinMaxPassword: true };
  };
}
export function haveAtleastOneLetter(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    let hasResult = false;
    const passwordReg = /^(?=.*[a-z])(?=.*[A-Z ]).*$/;
    hasResult = passwordReg.test(control.value);
    //  return result ? null : { invalidOneUpLower: true };
    const passwordRegEx = /^(?:(?=.*\d)(?=.*[a-zA-Z ]){2,}.*)$/;
    result = passwordRegEx.test(control.value);
    return result && hasResult ? null : { invalidAtLeastOnePassword: true };
  };
}
export function allowSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const passwordRegEx = /^((?=.*[!.&@-]).*$)([a-zA-Z\d!.&@-]*$)/;
    result = passwordRegEx.test(!control.value ? ' ' : control.value);

    return result ? null : { invalidAcceptSymbols: true };
  };
}
export function allowAtLeastOneSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;

    const passwordRegEx = /^[a-zA-Z\d!.&@-]*$/;
    result = passwordRegEx.test(!control.value ? ' ' : control.value);
    return result ? null : { invalidAcceptSymbols: true };
  };
}

export function allowMaxTwoCharRepeat(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const passwordRegEx = /(.)\1\1/i;
    result = passwordRegEx.test(!control.value ? '   ' : control.value);
    return result ? { invalidMaxTwoCharRepeat: true } : null;
  };
}

export function passwordMatchValidator(control: AbstractControl) {
  const password: string = control.get('newPassword')?.value;
  const confirmPassword: string = control.get('verifyNewPassword')?.value;
  const notMatched = password !== confirmPassword;

  const existingErrors = control.get('verifyNewPassword')?.errors;
  if (existingErrors) {
    existingErrors['NoPassswordMatch'] = notMatched;

    control
      .get('verifyNewPassword')
      ?.setErrors(
        Object.keys(existingErrors).length === 1 &&
          !existingErrors['NoPassswordMatch']
          ? null
          : existingErrors,
      );
  } else {
    control
      .get('verifyNewPassword')
      ?.setErrors(notMatched ? { NoPassswordMatch: notMatched } : null);
  }
}
export function minMaxWithNoSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    let hasResult = false;
    let hasSymbols = false;
    const passwordRegEx = /^\S(?:(?=.*[a-zA-Z]){1,}.*)$/;

    result = passwordRegEx.test(control.value);
    //  return result ? null : { invalidOneUpLower: true };
    const passwordReg = /^.{5,32}$/;
    hasResult = passwordReg.test(control.value);
    const pwdRegEx = /^[A-Za-z0-9 ]+$/;
    hasSymbols = pwdRegEx.test(control.value);

    return result && hasResult && hasSymbols
      ? null
      : { invalidMinMaxNoSymbols: true };
  };
}
export function notAllowSpaceAndSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const passwordRegEx = /^(\d|\w)+$/;
    result = passwordRegEx.test(control.value);

    return result ? null : { notAllowSpaceAndSymbols: true };
  };
}
export function moreThanFiveConsecutiveDigits(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const regex = new RegExp('\\d{6,}');
    result = regex.test(control.value);
    return result ? { invalidFiveNumbers: true } : null;
  };
}
export function moreThanThreeConsecutiveDigits(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const regex = new RegExp('\\d{4,}');
    result = regex.test(control.value);
    return result ? { invalidThreeNumbers: true } : null;
  };
}
export function validatePasswordForNames(toValidate: string): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    if (
      control.value &&
      toValidate &&
      control.value.toLowerCase().includes(toValidate.toLocaleLowerCase())
    ) {
      result = true;
    }
    return result ? { invalidPwdNameValidation: true } : null;
  };
}
export function validatePasswordForCigna(): ValidatorFn {
  return (control: AbstractControl) => {
    let result = false;
    const toValidate = 'cigna';
    if (
      control.value &&
      control.value.toLowerCase().includes(toValidate.toLocaleLowerCase())
    ) {
      result = true;
    }
    return result ? { invalidPwdCignaValidation: true } : null;
  };
}
export function checkValidSecurityAnswer(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const firstNameRegEx = /^[a-zA-Z0-9-,. ']*$/;
    result = firstNameRegEx.test(control.value);
    return result ? null : { invalidSecurityAnswer: true };
  };
}
export function checkConsecutiveCharacters(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const firstNameRegEx =
      /^(?!.*[-]{2})(?!.*[,]{2})(?!.*[']{2})(?!.*[.]{2})(?!.*[ ]{2})[a-zA-Z0-9-,. ']*$/;
    result = firstNameRegEx.test(control.value);
    return result ? null : { checkAnswer: true };
  };
}

// Custom validator function
export function minOneCheckBoxValidator(
  control: AbstractControl,
): { [key: string]: boolean } | null {
  const supplementProducts: SupplementProductByState[] = control.value;
  const anyCheckBoxSelected = supplementProducts.some(
    (x) => x.cignaHealthSelected || x.loyalAmericanSelected,
  );
  if (anyCheckBoxSelected) {
    return null;
  }
  return { minOneCheckBoxValidator: true };
}
